import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved -- Swiper modules are not exported as default
import { Navigation, Pagination } from 'swiper/modules';

const carousel = document.querySelector('.plarium-play__games-carousel__slider .swiper');

if (carousel) {
  /**
   * Initialize Carousel for the Plarium Play games
   */
  const initializeCarousel = () =>
    new Swiper(carousel, {
      loop: true,
      loopAddBlankSlides: false,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
        767: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 20,
        },
        1366: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 30,
        },
      },
      pagination: {
        el: '.plarium-play__games-carousel__slider__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.plarium-play__games-carousel__slider__next',
        prevEl: '.plarium-play__games-carousel__slider__prev',
      },
      modules: [Navigation, Pagination],
    });

  window.addEventListener('DOMContentLoaded', () => {
    initializeCarousel();
  });
}
